import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { visualizacionesApi } from '../api/visualizaciones.api'
import type { VideoSeguimientoCreateInput } from '../types'

const KEYS = {
  all: ['visualizaciones'] as const,
  list: (params: object) => [...KEYS.all, 'list', params] as const,
  reporte: (id: number, params: object) => [...KEYS.all, 'reporte', id, params] as const,
  laboratorios: () => [...KEYS.all, 'laboratorios'] as const,
}

export function useSeguimientos(params?: {
  laboratorio_id?: number
  activo?: boolean
  search?: string
  page?: number
  page_size?: number
}) {
  return useQuery({
    queryKey: KEYS.list(params ?? {}),
    queryFn: () => visualizacionesApi.listarSeguimientos(params),
  })
}

export function useCrearSeguimiento() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: VideoSeguimientoCreateInput) =>
      visualizacionesApi.crearSeguimiento(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all })
    },
  })
}

export function useEliminarSeguimiento() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => visualizacionesApi.eliminarSeguimiento(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.all })
    },
  })
}

export function useReporte(
  id: number,
  params?: { desde?: string; hasta?: string; incluir_usuarios?: boolean },
) {
  return useQuery({
    queryKey: KEYS.reporte(id, params ?? {}),
    queryFn: () => visualizacionesApi.obtenerReporte(id, params),
    enabled: id > 0,
  })
}

export function useLaboratorios() {
  return useQuery({
    queryKey: KEYS.laboratorios(),
    queryFn: () => visualizacionesApi.listarLaboratorios(),
    staleTime: 5 * 60 * 1000,
  })
}
